import {Injectable} from "@angular/core";
import {HuiHowlerPlayer} from "@hidat/huijs-player";

/**
 * Root-scoped Angular singleton that exposes the Howler.js audio engine to the rest of the player.
 *
 * Inherits the full playback API from `HuiHowlerPlayer` → `HuiAudioPlayer`:
 * - Signals: `playing`, `paused`, `playbackStartError`
 * - Subjects: `playbackStatusSource`, `playbackErrorSource`, `playbackProgressSource`
 * - Methods: `play()`, `retryPlay()`, `stop()`, `pause()`, `resume()`, `togglePlayback()`,
 *   `position()`, `setPosition()`, `back()`, `forward()`, `setPlaybackRate()`, `playbackStatus()`
 *
 * `PlaybackService` is the primary consumer. UI components should read higher-level state
 * from `PlaybackService` rather than subscribing to the engine subjects directly.
 */
@Injectable({providedIn: 'root'})
export class PlayerEngineService extends HuiHowlerPlayer {
  constructor() {
    super();
  }
}
